module.exports = __webpack_public_path__ + "static/media/remove.2e093051.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/remove.svg
// module id = 397
// module chunks = 0